<template>
  <div>
    <div class="md-layout-item md-size-100 mt-30 center-content mnue-employees">
      <md-button @click="personal_data" class="btn_nanosoft"
        >البيانات الشخصية</md-button
      >
      <md-button @click="Functional_data" class="btn_nanosoft">
        البيانات الوظيفية
      </md-button>
      <md-button
        v-if="isSalariesEnabled == 'true'"
        @click="Financial_data"
        class="btn_nanosoft"
        >البيانات المالية</md-button
      >
      <md-button @click="Qualifications_" class="btn_nanosoft"
        >المؤهلات العلمية</md-button
      >
      <md-button @click="Vacation" class="btn_nanosoft"
        >أرصدة وخصميات الإجازات السنوية</md-button
      >
      <!-- <md-button @click="Assignment" class=" btn_nanosoft">الإنتداب لجهة اخرى</md-button> -->

      <md-button class="md-success btn_nanosoft">الحالة الوظيفية</md-button>
      <md-button @click="EmployeeDocuments" class="btn_nanosoft"
        >مستندات الموظف</md-button
      >
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <md-card class="p-25">
            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-field>
                    <label>الموظف</label>
                    <md-input
                      v-model="fullName"
                      v-if="employeeId != 'new'"
                      disabled
                    ></md-input>
                  </md-field>
                </div>

                <div
                  v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-field>
                    <label>الوضع الوظيفي</label>
                    <md-select v-model="CurrentJobStatus">
                      <md-option value="1">مستمر</md-option>
                      <md-option value="2">منتدب إلى جهة </md-option>
                      <md-option value="3">إيقاف مؤقت</md-option>
                      <md-option value="4">متفرغ</md-option>
                      <md-option value="5">مكلف</md-option>
                      <md-option value="6">تدريب</md-option>
                      <md-option value="7">إجازة من غير مرتب</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-else
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-field>
                    <label>الوضع الوظيفي</label>
                    <md-select v-model="CurrentJobStatus">
                      <md-option value="1">مستمر</md-option>
                      <md-option value="3">إيقاف مؤقت</md-option>
                      <md-option value="4">متفرغ</md-option>
                      <md-option value="5">مكلف</md-option>
                      <md-option value="6">تدريب</md-option>
                      <md-option value="7">إجازة من غير مرتب</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '3'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>سبب الايقاف</label>
                    <md-input v-model="Reason"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '3'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label> رقم قرار الإيقاف</label>
                    <md-input type="number" v-model="LetterNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '3'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="StartDate">
                    <label class="mr-28">تاريخ بداية الإيقاف</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '3'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="EndDate">
                    <label class="mr-28">تاريخ نهاية الإيقاف</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '4'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>سبب التفرغ</label>
                    <md-input v-model="Reason"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '4'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label> رقم قرار التفرغ</label>
                    <md-input type="number" v-model="LetterNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '4'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="StartDate">
                    <label class="mr-28">تاريخ بداية التفرغ</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '4'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="EndDate">
                    <label class="mr-28">تاريخ نهاية التفرغ</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '7'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>سبب الإجازة</label>
                    <md-input v-model="Reason"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '7'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label> رقم قرار الإجازة</label>
                    <md-input type="number" v-model="LetterNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '7'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="StartDate">
                    <label class="mr-28">تاريخ البداية</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '7'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="EndDate">
                    <label class="mr-28">تاريخ النهاية</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '5'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>سبب التكليف</label>
                    <md-input v-model="Reason"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '5'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label> رقم قرار التكليف</label>
                    <md-input type="number" v-model="LetterNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '5'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="StartDate">
                    <label class="mr-28">تاريخ بداية التكليف</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '5'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="EndDate">
                    <label class="mr-28">تاريخ نهاية التكليف</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '6'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>سبب التدريب</label>
                    <md-input v-model="Reason"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '6'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label> رقم قرار التدريب</label>
                    <md-input type="number" v-model="LetterNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '6'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="StartDate">
                    <label class="mr-28">تاريخ بداية التدريب</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '6'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="EndDate">
                    <label class="mr-28">تاريخ نهاية التدريب</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '2'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label> رقم قرار الانتداب</label>
                    <md-input type="number" v-model="LetterNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '2'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>الجهة المنتدب إليها</label>
                    <md-input v-model="DelegatedTo"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentJobStatus == '2'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="StartDate">
                    <label class="mr-28">تاريخ بداية الندب</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '2'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="EndDate">
                    <label class="mr-28">تاريخ انتهاء الندب</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentJobStatus == '2'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>نوع الندب</label>
                    <md-select v-model="DelegationType">
                      <md-option value="1">ندب مع الوظيفة</md-option>
                      <md-option value="2">ندب تام</md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-datepicker :md-open-on-focus="false" v-model="endDateP">
                    <label class="mr-28">تاريخ الإنهاء</label>
                  </md-datepicker>
                </div> -->

                <div class="md-layout-item md-size-100 mt-25 center-content">
                  <md-button
                    v-if="!isEndedService"
                    @click="Save"
                    class="md-success btn_nanosoft"
                    >حفظ</md-button
                  >
                  <md-button @click="clear" class="md-info btn_nanosoft"
                    >جديد</md-button
                  >
                  <!-- <md-button @click="endStatus"  class=" btn_nanosoft">إنهاء</md-button> -->
                  <md-button @click="gobBack" class="md-info btn_nanosoft"
                    >رجوع</md-button
                  >
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <div class="md-layout flex-content-left">
            <div class="md-layout-item md-size-15">
              <md-table-toolbar>
                <md-field>
                  <label for="pages">عدد النتائج</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </md-table-toolbar>
            </div>
          </div>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="الوضع الوظيفي">{{
                item.currentJobStatusString
              }}</md-table-cell>

              <md-table-cell md-label="تاريخ البداية">{{
                item.startDate == null ? "-" : convert(item.startDate)
              }}</md-table-cell>

              <md-table-cell md-label="تاريخ النهاية">{{
                item.endDate == null ? "-" : convert(item.endDate)
              }}</md-table-cell>

              <md-table-cell md-label="الحالة">{{
                item.isActive == true ? "فعالة" : null
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../../components/service/HTTP.js";
import { Pagination } from "@/components";
import users from "../../users";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../../env";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
    this.isSalariesEnabled = localStorage.getItem("isSalariesEnabled");
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
  },
  components: {
    Pagination,
    // SlideYDownTransition
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      isEndedService: false,
      privateCompanyMode: false,
      endDateP: null,
      LetterNumber: null,
      StartDate: null,
      EndDate: null,
      Reason: null,
      errorMessage: null,
      CurrentJobStatus: 1,
      DelegatedTo: "",
      From: null,
      To: null,
      DelegationType: 1,
      CalculateSalariesAndBonus: false,
      btn: "new",
      idTable: null,
      fullName: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: null,
      propsToSearch: ["Titel", "Severity", "Status"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const m = moment(date);
      return m.isValid() ? m.format("YYYY-MM-DD") : null;
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        // if (!this.DelegatedTo) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء ادخال الجهة المنتدب إليها"
        //   );
        // }
        // if (!this.From) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء ادخال تاريخ بداية الندب"
        //   );
        // }

        // if (!this.To) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء ادخال تاريخ نهاية الندب"
        //   );
        // }

        let schema = {
          LetterNumber: this.LetterNumber,
          CurrentJobStatus: parseInt(this.CurrentJobStatus),

          StartDate: this.formatDate(this.StartDate),
          EndDate: this.formatDate(this.EndDate),

          Reason: this.Reason,
          DelegatedTo: this.DelegatedTo == null ? "" : this.DelegatedTo,
          DelegationType: this.DelegationType,
        };

        if (this.btn === "new") {
          let employeeId = this.$route.params.id;
          let result = await axios.post(
            `${env.HR()}/api/jobStatuses/${employeeId}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        } else {
          let result = await axios.put(
            `${env.HR()}/api/jobStatuses/${this.idTable}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.init();
        this.clear();
        this.btn = "new";

        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    async endStatus() {
      try {
        this.fullName = localStorage.getItem("name");
        let T = localStorage.getItem("Nannotoken");
        let employeeId = this.$route.params.id;
        if (employeeId == "new") {
          return;
        }

        if (this.EndDate == null) {
          this.EndDate = null;
        } else {
          this.EndDate = this.convert(this.EndDate);
        }
        let token = atob(T);
        let result = await axios.patch(
          `${env.HR()}/api/jobStatuses/EndStatus/${employeeId}/${this.EndDate}`,
          null,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        return this.notifyVue("top", "center", "success", " تم  الإنهاء ");
      } catch (error) {
        this.message(error);
      }
    },

    async init() {
      try {
        this.fullName = localStorage.getItem("name");
        let T = localStorage.getItem("Nannotoken");
        let employeeId = this.$route.params.id;
        if (employeeId == "new") {
          return;
        }
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/jobStatuses?employeeId=${employeeId}`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.isEndedService = result.data.data.isEndedService;

        this.tableData = result.data.data.jobStatuses;
      } catch (error) {
        this.message(error);
      }
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
      this.CurrentJobStatus = item.currentJobStatus;
      this.LetterNumber = item.letterNumber;
      this.StartDate = new Date(item.startDate);
      this.EndDate = new Date(item.endDate);
      this.Reason = item.reason;
      this.DelegationType = item.delegationType;
      this.DelegatedTo = item.delegatedTo;

      this.idTable = item.id;
      this.btn = "Edit";
    },

    gobBack() {
      this.$router.push("/pages/employees");
    },

    Functional_data() {
      let employeeId = this.$route.params.id;
      if (employeeId) {
        this.$router.push(
          "/pages/employee/Functionaldata/" + this.$route.params.id
        );
      }
    },

    Financial_data() {
      this.$router.push(
        "/pages/employee/Financialdata/" + this.$route.params.id
      );
    },

    personal_data() {
      this.$router.push("/pages/employee/info/" + this.$route.params.id);
    },

    Qualifications_() {
      this.$router.push(
        "/pages/employee/Certifications/" + this.$route.params.id
      );
    },

    Vacation() {
      this.$router.push("/pages/employee/Vacation/" + this.$route.params.id);
    },

    Assignment() {
      this.$router.push("/pages/employee/Assignment/" + this.$route.params.id);
    },

    EmployeeDocuments() {
      this.$router.push(
        "/pages/employee/EmployeeDocuments/" + this.$route.params.id
      );
    },
    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    clear() {
      this.LetterNumber = null;
      this.StartDate = null;
      this.EndDate = null;
      this.Reason = null;
      this.DelegatedTo = "";
      this.btn = "new";
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/jobStatuses/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            this.message(error);
          }
        }
      });
    },

    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
  watch: {
    CurrentJobStatus() {
      if (this.btn != "Edit") {
        this.LetterNumber = null;
        this.StartDate = null;
        this.EndDate = null;
        this.Reason = null;
      }
    },
  },
};
</script>